import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col mb-8 mb-12" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "flex flex-row mt-5" }
const _hoisted_4 = { class: "w-1/4 px-2" }
const _hoisted_5 = {
  key: 0,
  class: "w-1/4 px-2"
}
const _hoisted_6 = { class: "w-1/4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex flex-row" }
const _hoisted_10 = { class: "flex flex-row" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "text-medium text-center p-3 mb-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_default_button = _resolveComponent("default-button")!
  const _component_ReportsSuppliers = _resolveComponent("ReportsSuppliers")!
  const _component_ReportsDetails = _resolveComponent("ReportsDetails")!
  const _component_ReportsParcels = _resolveComponent("ReportsParcels")!
  const _component_ReportsCountries = _resolveComponent("ReportsCountries")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("report.title")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FormInput, {
            elementData: _ctx.state.startDateElementData,
            initialState: _ctx.state.startDateInitialState,
            onFormInputValueUpdate: _ctx.methods.startDateChange
          }, null, 8, ["elementData", "initialState", "onFormInputValueUpdate"])
        ]),
        (_ctx.state.isParentCustomer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_FormInput, {
                elementData: _ctx.state.reportTypeElementData,
                initialState: _ctx.state.reportTypeInitialState,
                onFormInputValueUpdate: _ctx.methods.reportTypeChange
              }, null, 8, ["elementData", "initialState", "onFormInputValueUpdate"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_default_button, {
            "injected-class": "px-6 py-3 mt-2 ml-4",
            disabled: _ctx.state.isLoading || _ctx.state.refreshDisabled,
            onClick: _ctx.methods.createReport
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.state.reportData || _ctx.state.refreshDisabled
                ? _ctx.$t("report.refresh_report")
                : _ctx.$t("report.create_report")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _hoisted_7
      ])
    ]),
    (!_ctx.state.isLoading && _ctx.state.reportData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_ReportsSuppliers, {
              class: "w-5/12",
              reportData: _ctx.state.reportData
            }, null, 8, ["reportData"]),
            _createVNode(_component_ReportsDetails, {
              class: "w-7/12",
              reportData: _ctx.state.reportData
            }, null, 8, ["reportData"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_ReportsParcels, {
              class: "w-1/2",
              reportData: _ctx.state.reportData
            }, null, 8, ["reportData"]),
            _createVNode(_component_ReportsCountries, {
              class: "w-1/2",
              reportData: _ctx.state.reportData
            }, null, 8, ["reportData"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.state.isLoading && !_ctx.state.reportData && _ctx.state.backendError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.state.backendError), {
            onReloadReport: _ctx.methods.getReportData
          }, null, 40, ["onReloadReport"]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_spinner, { class: "my-auto my-auto mx-auto" })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      type: "warning",
      size: "small",
      hideCancelButton: true,
      modelValue: _ctx.state.showModal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.showModal) = $event)),
      onConfirmClick: _ctx.methods.closeModal,
      onCancelClick: _ctx.methods.closeModal
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("report.modal.title")), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t(_ctx.state.modalMessage)), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "onConfirmClick", "onCancelClick"])
  ]))
}